import { Button, styled, Typography, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { useNavigate } from 'react-router-dom'
import { REFERRAL_PROGRAM_ROUTE } from '../../../../constants/routing.constants'
import { theme } from '../../../../theme'
import ReferralLinkInput from '../../ReferralProgramPage/components/ReferralLinkInput'
import { Block } from './Block'

const ReferralBlockWrapper = styled(Block)(({ isWebView }) => ({
    padding: '24px',
    height: '100%',
    border: isWebView ? 'none' : '1px solid #E9EAED',
    [theme.breakpoints.down('md')]: {
        padding: '12px',
    },
}))

export const ReferralBlock = ({ isWebView = false }) => {
    const navigate = useNavigate()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <ReferralBlockWrapper isWebView={isWebView}>
            <Typography
                sx={{
                    marginBottom: '12px',
                    color: '#000',
                }}
                variant="h3">
                Реферальная программа
            </Typography>
            <Typography
                sx={{
                    color: '#5A5F72',
                    marginBottom: isMobile ? '16px' : 3,
                }}
                variant="body2">
                Делитесь персональной ссылкой и наслаждайтесь выгодой. Получайте бонусы и
                зарабатывайте коины вместе с друзьями
            </Typography>
            <Grid
                sx={{
                    display: 'flex',
                    gap: '8px',
                }}>
                <ReferralLinkInput
                    sx={{
                        mr: 1,
                        width: '100%',
                        borderRadius: '100px',
                        background: '#ffffff',
                        '& .MuiInputBase-root': {
                            backgroundColor: '#ffffff',
                        },
                        [theme.breakpoints.down('md')]: {
                            width: `100%`,
                        },
                    }}
                />
                <Button
                    id="ButtonReferralProgram_Finances"
                    onClick={() => navigate(REFERRAL_PROGRAM_ROUTE)}
                    variant="outlined"
                    color="primary">
                    Подробнее
                </Button>
            </Grid>
        </ReferralBlockWrapper>
    )
}
